import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { SelectionService } from "./selection.service";
import { EnumModoSelecao } from "../enums/EnumModoSelecao";
import { ProgressMessageModel } from "../models/ProgressMessageModel";

@Injectable()
export class StatusService {
  private selectedTool: number = null;

  private msgStatus = "";
  private msgStatus$ = new BehaviorSubject<string>(this.msgStatus);

  private appOffline = false;
  private appOffline$ = new BehaviorSubject<boolean>(this.appOffline);

  private message = "";
  private message$ = new BehaviorSubject<string>(this.message);

  private progressoOperacao = 0;
  private progressoOperacao$ = new BehaviorSubject<number>(
    this.progressoOperacao
  );

  private mensagensProgresso: ProgressMessageModel[] = [];
  private mensagensProgresso$ = new BehaviorSubject<ProgressMessageModel[]>(
    this.mensagensProgresso
  );

  constructor(private selectionService: SelectionService) {
    this.initialize();
  }

  public getPrimeiroDownloadConcluido(): boolean {
    const dataUltimaAtualizacao = this.getDataUltimaAtualizacao();
    if (dataUltimaAtualizacao) {
      return true;
    }
    return false;
  }

  public getIsAppOnline(): boolean {
    return !this.appOffline;
  }

  public getDataUltimaAtualizacao(): Date {
    const dataRecuperada = localStorage.getItem("DataUltimaAtualizacao");

    if (dataRecuperada) {
      const dataFormatada = new Date(dataRecuperada);
      return dataFormatada;
    }

    return null;
  }

  public setDataUltimaAtualizacao(value: Date) {
    localStorage.setItem("DataUltimaAtualizacao", value.toISOString());
  }

  public mostrarMensagemProgresso(mensagem: string, tarefa: string) {
    const message = new ProgressMessageModel();
    message.message = mensagem;
    message.task = tarefa;

    const pilha = this.mensagensProgresso;
    const iItemPilha = pilha.findIndex((p) => p.task === message.task);

    if (iItemPilha === -1) {
      pilha.push(message);
    } else {
      pilha[iItemPilha] = message;
    }

    this.mensagensProgresso = pilha;
    this.updateMensagensProgresso();
  }

  public ocultarMensagemProgresso(tarefa: string) {
    this.mensagensProgresso = [];
    this.updateMensagensProgresso();
  }

  public setProgressoOperacao(progresso: number = null) {
    this.progressoOperacao = progresso;
    this.updateProgressoOperacao();
  }

  public setMessage(message: string = null) {
    this.message = message;
    this.updateMessage();
  }
  public setAppOffline(appOffline: boolean) {
    this.appOffline = appOffline;
    this.updateAppOffline();
  }
  public updateAppOffline() {
    this.appOffline$.next(this.appOffline);
  }

  public getAppOffline(): Observable<boolean> {
    return this.appOffline$.asObservable();
  }
  public updateMessage() {
    this.message$.next(this.message);
  }
  public getMessage(): Observable<string> {
    return this.message$.asObservable();
  }
  public updateMsgStatus() {
    this.msgStatus$.next(this.msgStatus);
  }

  public getMsgStatus(): Observable<string> {
    return this.msgStatus$.asObservable();
  }

  public updateProgressoOperacao() {
    this.progressoOperacao$.next(this.progressoOperacao);
  }

  public getProgressoOperacao(): Observable<number> {
    return this.progressoOperacao$.asObservable();
  }

  public updateMensagensProgresso() {
    this.mensagensProgresso$.next(this.mensagensProgresso);
  }

  public getMensagensProgresso(): Observable<ProgressMessageModel[]> {
    return this.mensagensProgresso$.asObservable();
  }

  public voidStatus() {
    this.msgStatus = this.getToolDescription(this.selectedTool);
    this.updateMsgStatus();
  }

  public setStatusMessage(message: string, timeout = false) {
    this.msgStatus = message;
    this.updateMsgStatus();

    if (timeout) {
      this.voidStatus();
    }
  }
  private getToolDescription(modo: EnumModoSelecao): string {
    switch (modo) {
      case EnumModoSelecao.Padrao:
        return "Modo de seleção";
      case EnumModoSelecao.Marcacao:
        return "Modo marcação";
      case EnumModoSelecao.MarcaTexto:
        return "Modo marca-texto";
      case EnumModoSelecao.Borracha:
        return "Modo borracha";
    }
  }

  private initialize() {
    this.selectionService.getSelection().subscribe((sel) => {
      if (sel) {
        this.selectedTool = sel.modo;
      }
      this.voidStatus();
    });
  }
}
